interface MediaQuery {
  screen: string
  width: string
  srcKey?: string
}
interface SponsorImageType {
  imageSrc: string
  link: string
  mediaQuery: MediaQuery[]
  sizes: { desktop: { width: number; height: number }; mobile: { width: number; height: number } }
  imageAlt: string
}

interface MediaType {
  imageSrc: string
  publishDate: string
  title: string
  linkTitle: string
  link: string
  mediaQuery: MediaQuery[]
  imageAlt: string
}

export const sponsors: SponsorImageType[] = [
  {
    imageSrc: 'donation/sponsors/bahr_new.png',
    link: 'https://bahr.no',
    mediaQuery: [
      { screen: '(max-width: 1023px)', width: '74px' },
      { screen: '(min-width: 1024px)', width: '132px' },
    ],
    sizes: {
      desktop: { width: 132, height: 130 },
      mobile: { width: 74, height: 73 },
    },
    imageAlt: 'bahr',
  },
  {
    imageSrc: 'donation/sponsors/accenture_new.png',
    link: 'https://www.accenture.com/no-en',
    mediaQuery: [
      { screen: '(max-width: 1023px)', width: '114px' },
      { screen: '(min-width: 1024px)', width: '204px' },
    ],
    sizes: {
      desktop: { width: 204, height: 56 },
      mobile: { width: 114, height: 32 },
    },

    imageAlt: 'accenture',
  },
  {
    imageSrc: 'donation/sponsors/hydro_new.png',
    link: 'https://www.hydro.com/en',
    mediaQuery: [
      { screen: '(max-width: 1023px)', width: '81px' },
      { screen: '(min-width: 1024px)', width: '145px' },
    ],
    sizes: {
      desktop: { width: 145, height: 145 },
      mobile: { width: 81, height: 81 },
    },
    imageAlt: 'hydro',
  },
  {
    imageSrc: 'donation/sponsors/hom_logo_new.png',
    link: 'https://www.houseofmath.com',
    mediaQuery: [
      { screen: '(max-width: 1023px)', width: '120px' },
      { screen: '(min-width: 1024px)', width: '215px' },
    ],
    sizes: {
      desktop: { width: 215, height: 41 },
      mobile: { width: 120, height: 23 },
    },
    imageAlt: 'hom_logo',
  },
  {
    imageSrc: 'donation/sponsors/montesori_new.png',
    link: 'https://drobakmontessori.no',
    mediaQuery: [
      { screen: '(max-width: 1023px)', width: '122px' },
      { screen: '(min-width: 1024px)', width: '219px' },
    ],
    sizes: {
      desktop: { width: 219, height: 76 },
      mobile: { width: 122, height: 43 },
    },
    imageAlt: 'montesorri',
  },
  {
    imageSrc: 'donation/sponsors/corporate_comm_new.png',
    link: 'https://corporatecommunications.no/en',
    mediaQuery: [
      { screen: '(max-width: 1023px)', width: '125px' },
      { screen: '(min-width: 1024px)', width: '223px' },
    ],
    sizes: {
      desktop: { width: 223, height: 53 },
      mobile: { width: 125, height: 30 },
    },

    imageAlt: 'corporate_comm',
  },
]

export const media: MediaType[] = [
  {
    imageSrc: 'donation/media/hom_pak_embassy_new.png',
    publishDate: '2023-08-13',
    title: 'Pakistan Embassy Norway',
    linkTitle: 'Embassy of Pakistan Norway',
    link: 'https://twitter.com/pakinnorway/status/1690633930922242049?s=46&t=jhu4iS9oXWj9hchqBRTyrw',
    mediaQuery: [{ screen: '(min-width: 280px)', width: '276px' }],
    imageAlt: 'Pakistan Embassy Norway',
  },
  {
    imageSrc: 'donation/media/media_pak_embassy_release.png',
    publishDate: '2023-08-13',
    title: 'House of Math has translated the portal to ukranian',
    linkTitle: 'LinkedIn',
    link: 'https://www.linkedin.com/posts/house-of-math_edtech-education-math-activity-7095792510966362113-Z6Rr?utm_source=share&utm_medium=member_desktop',
    mediaQuery: [{ screen: '(min-width: 280px)', width: '276px' }],
    imageAlt: 'House of Math has translated the portal to ukranian',
  },
  {
    imageSrc: 'donation/media/house-of-math_new.png',
    publishDate: '2023-08-08',
    title: 'The magic of Math for Ukraine',
    linkTitle: 'LinkedIn',
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7095100247722385408/',
    mediaQuery: [{ screen: '(min-width: 280px)', width: '276px' }],
    imageAlt: 'The magic of Math for Ukraine',
  },
]

export const donationAmount = [75, 125, 250, 500, 1000]
